import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import Loading from "UIComponents/Loading";
import AiQuestionAssistant from "ClassRoom/components/AddAssignment/AiQuestionAssistant/AiQuestionAssistant";
import { getWorksheetAssistantContainerStyle } from "ClassRoom/components/AddAssignment/AiQuestionAssistant/modules/Utils";
import { WORKSHEET_ELEMENT_IDS } from "Worksheet/modules/WorksheetConstants";
import AIAssessmentTools from "../../../AIAssessmentTools";

import classes from "./AssistantAndToolWrapper.scss";

const AssistantAndToolWrapper = ({
  showWorksheetAssistant,
  questionAIConversationId,
  questionInfoForAssistant,
  parentId,
  isDraft,
  courseId,
  activeQuestionId,
  unitPlanId,
  sourceFrom,
  portalType,
  creationMode,
  selectedCourse,
  isFromUnitPlan,
  worksheetDetailsRef,
  handleShowQuestionAssistant,
  showFullScreenLoader,
  isAIAssessmentToolsOpen,
  assessmentTools,
  assessmentDetails,
  handleCloseAIAssessmentTools,
  getAssessmentRefetch,
  assessmentToolConversationId,
}) => {
  return (
    <>
      {/* WORKSHEET QUESTION ASSISTANT */}
      {showWorksheetAssistant && (
        <div className={classes.aiAssistantWrapper}>
          {_.isEmpty(questionAIConversationId) ? (
            <Loading
              containerStyle={getWorksheetAssistantContainerStyle(true)}
            />
          ) : (
            <AiQuestionAssistant
              mode="edit"
              leId={parentId}
              isDraft={isDraft}
              courseId={courseId}
              key={activeQuestionId}
              unitPlanId={unitPlanId}
              sourceFrom={sourceFrom}
              portalType={portalType}
              isQuestionAssistant={true}
              creationMode={creationMode}
              selectedCourse={selectedCourse}
              isFromUnitPlan={isFromUnitPlan}
              question={questionInfoForAssistant}
              middlePaneRef={worksheetDetailsRef}
              setShowAssistantRightPane={handleShowQuestionAssistant}
              setAssessmentFullScreenLoader={showFullScreenLoader}
            />
          )}
        </div>
      )}

      {/* AI ASSESSMENT TOOLS */}
      {isAIAssessmentToolsOpen && (
        <div
          className={classes.aiAssistantWrapper}
          id={WORKSHEET_ELEMENT_IDS.WORKSHEET_AI_ASSESSMENT_TOOLS_ID}
        >
          <AIAssessmentTools
            mode="edit"
            isDraft={isDraft}
            courseId={courseId}
            entityType="WORKSHEET"
            portalType={portalType}
            sourceFrom={sourceFrom}
            assessmentId={parentId}
            unitPlanId={unitPlanId}
            creationMode={creationMode}
            isQuestionAssistant={false}
            isFromUnitPlan={isFromUnitPlan}
            selectedCourse={selectedCourse}
            assessmentTools={assessmentTools}
            middlePaneRef={worksheetDetailsRef}
            assessmentDetails={assessmentDetails}
            onClose={handleCloseAIAssessmentTools}
            getAssessmentRefetch={getAssessmentRefetch}
            aiConversationId={assessmentToolConversationId}
            assessmentToolConversationId={assessmentToolConversationId}
          />
        </div>
      )}
    </>
  );
};

export default AssistantAndToolWrapper;

AssistantAndToolWrapper.propTypes = {
  showWorksheetAssistant: PropTypes.bool,
  questionAIConversationId: PropTypes.string,
  questionInfoForAssistant: PropTypes.object,
  parentId: PropTypes.string,
  isDraft: PropTypes.bool,
  courseId: PropTypes.string,
  activeQuestionId: PropTypes.string,
  unitPlanId: PropTypes.string,
  sourceFrom: PropTypes.string,
  portalType: PropTypes.string,
  creationMode: PropTypes.string,
  selectedCourse: PropTypes.object,
  isFromUnitPlan: PropTypes.bool,
  worksheetDetailsRef: PropTypes.object,
  handleShowQuestionAssistant: PropTypes.func,
  showFullScreenLoader: PropTypes.func,
  isAIAssessmentToolsOpen: PropTypes.bool,
  assessmentTools: PropTypes.array,
  assessmentDetails: PropTypes.object,
  handleCloseAIAssessmentTools: PropTypes.func,
  getAssessmentRefetch: PropTypes.func,
  assessmentToolConversationId: PropTypes.string,
};

AssistantAndToolWrapper.defaultProps = {
  showWorksheetAssistant: false,
  questionAIConversationId: "",
  questionInfoForAssistant: {},
  parentId: "",
  isDraft: false,
  courseId: "",
  activeQuestionId: "",
  unitPlanId: "",
  sourceFrom: "",
  portalType: "",
  creationMode: "",
  selectedCourse: {},
  isFromUnitPlan: false,
  worksheetDetailsRef: null,
  isAIAssessmentToolsOpen: false,
  assessmentTools: [],
  assessmentDetails: {},
  assessmentToolConversationId: "",
};
